import i18next from '../../i18n';

const getLocaleTextConstants = () => ({
  noRowsLabel: i18next.t('common.noData'),
  noResultsOverlayLabel: i18next.t('datagrid.noResults'),

  // Density selector toolbar button text
  toolbarDensity: i18next.t('datagrid.density'),
  toolbarDensityLabel: i18next.t('datagrid.density'),
  toolbarDensityCompact: i18next.t('datagrid.densityCompact'),
  toolbarDensityStandard: i18next.t('datagrid.densityStandard'),
  toolbarDensityComfortable: i18next.t('datagrid.densityComfortable'),

  // Columns selector toolbar button text
  toolbarColumns: i18next.t('common.columns'),
  toolbarColumnsLabel: i18next.t('datagrid.selectColumns'),

  // Filters toolbar button text
  toolbarFilters: i18next.t('common.filters'),
  toolbarFiltersLabel: i18next.t('common.showFilters'),
  toolbarFiltersTooltipHide: i18next.t('datagrid.hideFilters'),
  toolbarFiltersTooltipShow: i18next.t('common.showFilters'),

  // Quick filter toolbar field
  toolbarQuickFilterPlaceholder: i18next.t('datagrid.search'),
  toolbarQuickFilterLabel: i18next.t('common.search'),
  toolbarQuickFilterDeleteIconLabel: i18next.t('common.clear'),

  // Export selector toolbar button text
  toolbarExport: i18next.t('common.export'),
  toolbarExportLabel: i18next.t('common.export'),
  toolbarExportCSV: i18next.t('datagrid.exportCsv'),
  toolbarExportPrint: i18next.t('datagrid.print'),
  toolbarExportExcel: i18next.t('datagrid.exportExcel'),

  // Columns panel text
  columnsPanelTextFieldLabel: i18next.t('datagrid.findColumn'),
  columnsPanelTextFieldPlaceholder: i18next.t('datagrid.columnTitle'),
  columnsPanelDragIconLabel: i18next.t('datagrid.reorderColumn'),

  // Columns management text
  columnsManagementSearchTitle: i18next.t('common.search'),
  columnsManagementNoColumns: i18next.t('datagrid.noColumns'),
  columnsManagementShowHideAllText: i18next.t('datagrid.showHideAll'),
  columnsManagementReset: i18next.t('filterPanel.reset'),

  // Filter panel text
  filterPanelAddFilter: i18next.t('filterPanel.addFilter'),
  filterPanelRemoveAll: i18next.t('datagrid.removeAll'),
  filterPanelDeleteIconLabel: i18next.t('common.delete'),
  filterPanelLogicOperator: i18next.t('datagrid.logicalOperator'),
  filterPanelOperator: i18next.t('datagrid.operator'),
  filterPanelOperatorAnd: i18next.t('datagrid.operatorAnd'),
  filterPanelOperatorOr: i18next.t('datagrid.operatorOr'),
  filterPanelColumns: i18next.t('common.columns'),
  filterPanelInputLabel: i18next.t('filterPanel.value'),
  filterPanelInputPlaceholder: i18next.t('datagrid.filterValue'),

  // Filter operators text
  filterOperatorContains: i18next.t('datagrid.contains'),
  filterOperatorEquals: i18next.t('datagrid.equals'),
  filterOperatorStartsWith: i18next.t('datagrid.startsWith'),
  filterOperatorEndsWith: i18next.t('datagrid.endsWith'),
  filterOperatorIs: i18next.t('datagrid.is'),
  filterOperatorNot: i18next.t('datagrid.isNot'),
  filterOperatorAfter: i18next.t('datagrid.after'),
  filterOperatorOnOrAfter: i18next.t('datagrid.onOrAfter'),
  filterOperatorBefore: i18next.t('datagrid.before'),
  filterOperatorOnOrBefore: i18next.t('datagrid.onOrBefore'),
  filterOperatorIsEmpty: i18next.t('datagrid.isEmpty'),
  filterOperatorIsNotEmpty: i18next.t('datagrid.isNotEmpty'),
  filterOperatorIsAnyOf: i18next.t('datagrid.isAnyOf'),
  'filterOperator=': '=',
  'filterOperator!=': '!=',
  'filterOperator>': '>',
  'filterOperator>=': '>=',
  'filterOperator<': '<',
  'filterOperator<=': '<=',

  // Header filter operators text
  headerFilterOperatorContains: i18next.t('datagrid.contains'),
  headerFilterOperatorEquals: i18next.t('datagrid.equals'),
  headerFilterOperatorStartsWith: i18next.t('datagrid.startsWith'),
  headerFilterOperatorEndsWith: i18next.t('datagrid.endsWith'),
  headerFilterOperatorIs: i18next.t('datagrid.is'),
  headerFilterOperatorNot: i18next.t('datagrid.isNot'),
  headerFilterOperatorAfter: i18next.t('datagrid.after'),
  headerFilterOperatorOnOrAfter: i18next.t('datagrid.onOrAfter'),
  headerFilterOperatorBefore: i18next.t('datagrid.before'),
  headerFilterOperatorOnOrBefore: i18next.t('datagrid.onOrBefore'),
  headerFilterOperatorIsEmpty: i18next.t('datagrid.isEmpty'),
  headerFilterOperatorIsNotEmpty: i18next.t('datagrid.isNotEmpty'),
  headerFilterOperatorIsAnyOf: i18next.t('datagrid.isAnyOf'),
  'headerFilterOperator=': i18next.t('datagrid.equals'),
  'headerFilterOperator!=': i18next.t('datagrid.notEquals'),
  'headerFilterOperator>': i18next.t('datagrid.greaterThan'),
  'headerFilterOperator>=': i18next.t('datagrid.greaterThanOrEqual'),
  'headerFilterOperator<': i18next.t('datagrid.lessThan'),
  'headerFilterOperator<=': i18next.t('datagrid.lessThanOrEqual'),

  // Total row amount footer text
  footerTotalRows: i18next.t('datagrid.totalRows'),

  footerRowSelected: (count) =>
    count !== 1
      ? `${count.toLocaleString()} ${i18next.t('datagrid.rowsSelected')}`
      : `${count.toLocaleString()} ${i18next.t('datagrid.rowSelected')}`,
});

export default getLocaleTextConstants;
